import Vue from 'vue'
import Router from 'vue-router'

const NonAuth = (resolve) => {
  import('@/components/NonAuth/NonAuth').then((module) => {
    resolve(module)
  })
}
const Login = (resolve) => {
  import('@/components/NonAuth/Login/Login').then((module) => {
    resolve(module)
  })
}


Vue.use(Router);
const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: NonAuth,
      children: [
        {
          path: '',
          component: Login
        },
        {
          path: 'login',
          component: Login
        },
      ]
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js